export default "__VITE_ASSET__2c041a1d__"